import { FC } from 'react';
import { Container } from '@mui/material';
import { GroupAdmin } from '../../components/Admin/GroupAdmin';
import { DebugModeToggle } from '../../components/Admin/DebugModeToggle';
import { DebugPanel } from '@app/components';

export const AdminHome: FC = () => {
  return (
    <>
      <Container component={'section'}>
        <DebugModeToggle />
        <DebugPanel displayItem={import.meta.env} />
        <GroupAdmin></GroupAdmin>
      </Container>
    </>
  );
};
